import { useSelector } from "react-redux";
import { Wrapper, CPButton } from "../../../constants/common/StyledGlobalConstants";
import { getPendoId } from "../../../util/cfstPendoUtils";

import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";
import PropTypes from "prop-types";

const { TABLET } = DEVICE_BREAKPOINTS;

function SaveService({ isSaveServiceDisabled, onClickHandler }) {
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  return (
    <Wrapper marginTop="1.5rem" width="100%">
      <CPButton
        role="button"
        id={getPendoId("save-service")}
        ariaLabel="SAVE SERVICE"
        size="large"
        fontSize="14px"
        boxButton={true}
        marginTop="1.5rem"
        disabled={isSaveServiceDisabled}
        buttonWidth={windowSize.width < TABLET ? "100%" : "auto"}
        style={{
          height: "2.5rem",
          marginTop: "0rem",
        }}
        onClick={onClickHandler}
      >
        SAVE SERVICE
      </CPButton>
    </Wrapper>
  );
}

SaveService.propTypes = {
  isSaveServiceDisabled: PropTypes.bool.isRequired,
  onClickHandler: PropTypes.func.isRequired,
};

export default SaveService;